//#region Tristate Checkbox

var tristateCheckbox = {
    /**
     * 
     * @param {any} $container Non required
     */
    init: function (container) {
        let $this = $(container)

        if (!$this || $this.length == 0) {
            $this = $(document)
        }

        $this.find('.checkbox-tristate-input').each(function (i, e) {
            let $cb = $(e)
            let state = $cb.data('value')
            if (typeof (state) === "boolean") {
                $cb.prop('indeterminate', false)
                $cb.prop('checked', state)
            } else {
                $cb.prop('indeterminate', true)
            }
        })
    },
    changeTwoState: function ($checkbox) {
        let isChecked = $checkbox.prop('checked')

        tristateCheckbox.setIndeterminate($checkbox, false)
        $checkbox.prop('checked', !isChecked)

        $checkbox.change()
        return $checkbox
    },
    changeThreeState: function ($checkbox) {
        let isChecked = $checkbox.prop('checked')
        let isIndeterminate = $checkbox.prop('indeterminate')

        if (isIndeterminate) {
            $checkbox.prop('indeterminate', false)
                .prop('checked', true)
        } else {
            if (isChecked) {
                $checkbox.prop('checked', false)
            } else {
                $checkbox.prop('indeterminate', true)
            }
        }

        $checkbox.change()
        return $checkbox
    },
    setIndeterminate: function ($checkbox, state = true) {
        $checkbox.prop('indeterminate', state)
        return $checkbox
    }
}

$(document).on('click', '.checkbox-tristate-label-toggle-three-state', function (e) {
    e.preventDefault()
    e.stopPropagation()

    let $this = $(this)
    let $cb = $('#' + $this.attr('for'))

    if ($cb.is(':disabled') !== true) {
        tristateCheckbox.changeThreeState($cb)
    }
})



$(document).on('click', '.checkbox-tristate-label-toggle-two-state', function (e) {
    e.preventDefault()
    e.stopPropagation()

    let $this = $(this)
    let $cb = $('#' + $this.attr('for'))

    if ($cb.is(':disabled') !== true) {
        tristateCheckbox.changeTwoState($cb)
    }
})

$(function () {
    tristateCheckbox.init()
})
//#endregion